export const getLocalStorageData = (key: string) => {
  let value = ''
  if (typeof window !== 'undefined') {
    try {
      value = localStorage.getItem(key) || ''
    } catch {
      // Storage blocked in private browsing / WebViews — see FZ-WEB-NEXTJS-FT
    }
  }
  return value
}

export const setLocalStorageData = (key: string, value: string) => {
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(key, value)
    } catch {
      // Storage blocked in private browsing / WebViews — see FZ-WEB-NEXTJS-FT
    }
  }
}

export const removeLocalStorageData = (key: string) => {
  if (typeof window !== 'undefined') {
    try {
      localStorage.removeItem(key)
    } catch {
      // Storage blocked in private browsing / WebViews — see FZ-WEB-NEXTJS-FT
    }
  }
}
